"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgSelect = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const context_1 = require("../../../../styles/context");
const css_1 = require("./css");
const FormRow_1 = require("../../../../3-list-item/FormRow");
const Scrollbox_1 = require("../../../Scrollbox");
const ArgSelectCompact_1 = require("./ArgSelectCompact");
const optionClass = (0, nano_theme_1.drule)({
    d: 'flex',
    alignItems: 'center',
    pd: '4px 8px',
    bdrad: '4px',
    cur: 'pointer',
    fz: '13px',
    lh: '1.4em',
    us: 'none',
});
const optionSelectedClass = (0, nano_theme_1.drule)({
    fontWeight: 600,
});
const unwrapSelect = (v) => {
    if (v && typeof v === 'object' && 'value' in v)
        return String(v.value ?? '');
    return v ?? '';
};
const ArgSelect = (props) => {
    const styles = (0, context_1.useStyles)();
    if (props.compact)
        return React.createElement(ArgSelectCompact_1.ArgSelectCompact, { ...props });
    const { param, value, onChange, onSubmit } = props;
    const v = unwrapSelect(value);
    const options = param.options ?? [];
    const optionCls = optionClass({
        '&:hover': { bg: styles.g(0, 0.06) },
    });
    const optionSelectedCls = optionSelectedClass({ bg: styles.g(0, 0.08) });
    return (React.createElement("div", { className: css_1.argBlockCss },
        React.createElement(FormRow_1.FormRow, { title: param.display?.() ?? param.name ?? param.id, descriptionAbove: true, description: param.description, optional: param.optional },
            React.createElement("div", { style: { margin: '-4px -16px' } },
                React.createElement(Scrollbox_1.Scrollbox, { style: { maxHeight: 200 } },
                    React.createElement("div", { style: { padding: '4px 16px' } }, options.map((opt) => {
                        const id = opt.id ?? opt.name;
                        const isSelected = v === id;
                        return (React.createElement("div", { key: id, className: optionCls + (isSelected ? ' ' + optionSelectedCls : ''), role: "option", "aria-selected": isSelected, tabIndex: 0, "data-menu-row": true, onClick: () => {
                                onChange(id);
                                onSubmit();
                            }, onKeyDown: (e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    onChange(id);
                                    onSubmit();
                                }
                            } },
                            opt.icon?.(),
                            React.createElement("span", { style: opt.icon ? { marginLeft: 8 } : void 0 }, opt.display?.() ?? opt.name ?? opt.id)));
                    })))))));
};
exports.ArgSelect = ArgSelect;
